import { Toast } from "native-base";

export const showToast = (title: any) => {
  return Toast.show({
    title: title,
  });
};
